import { useState } from 'react';

const useModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalChildren, setModalChildren] = useState();
    const [modalOuterClass, setModalOuterClass] = useState('');
    const [modalInnerClass, setModalInnerClass] = useState('');

    return {
        isModalOpen,
        modalChildren,
        modalOuterClass,
        modalInnerClass,
        setIsModalOpen,
        setModalChildren,
        setModalOuterClass,
        setModalInnerClass,
    };
};

export default useModal;
